import GoogleTagManager from "../../../services/GoogleTagManager"

class GtmTracker {
  constructor({
    name,
    area,
    section,
    gaAction = name,
    gaCategory = area,
    gaLabel = section,
    gaValue,
    gtmEventData
  } = {}) {
    this.action = gaAction
    this.category = gaCategory
    this.label = gaLabel
    this.value = gaValue
    this.gtmEventData = gtmEventData
  }

  setLinkText(text) {
    if (!this.label) {
      this.label = text
    }
  }

  setLinkUrl(url) {
    if (!this.label) {
      this.label = url
    }
  }

  setCurrentPage(url) {
    if (!this.label) {
      this.label = url
    }
  }

  sendEvent(eventParameters) {
    GoogleTagManager.sendEvent(this, eventParameters)
  }
}

export default GtmTracker
